<template>
  <div id="localization-field" class="field">
    <div id="localization" style="position: relative; top: 0; left: 0;">
      <a v-for="locale in $i18n.availableLocales"
         :key="`locale-${locale}`"
         @click="updateLocale(locale)"
         :style="$i18n.locale === locale ? 'border: solid 1px #bfbdbd;' : ''"
      >
        <img :src="blankFlag" :class="`flag flag-${locale}`" :alt="locale" />
      </a>
    </div>
  </div>
</template>

<script>
import blankFlag from '../../assets/img/language/blank.png';
import authService from '@/services/auth';

export default {
  name: 'LanguageIcons',
  data() {
    return {
      blankFlag,
    };
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale;
      authService.setLocale(locale);
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none !important;
}
#localization-field {
  line-height: 0;
  padding: 8px 10px 8px;
  flex-direction: column;
  align-items: center;
  display: flex;
}
#localization a {
  background: rgba(255, 255, 255, 0.15) none repeat scroll 0 0;
  border: 1px solid white;
  border-radius: 50%;
  display: block;
  float: left;
  height: 34px;
  line-height: 34px;
  margin-right: 7px;
  text-align: center;
  width: 34px;
}

#localization a:hover {
  background: white none repeat scroll 0 0;
}

#localization a.active, #localization a.active:hover {
  background: rgba(255, 255, 255, 0.5) none repeat scroll 0 0;
}

#localization .flag {
  display: inline-block;
  position: relative;
  top: 13%;
  transform: translateY(-50%);
  width: 16px;
  height: 11px;
  background: url("../../assets/img/language/flags.png") no-repeat;
}

#localization .flag.flag-en {
  background-position: -16px 0;
}

#localization .flag.flag-de {
  background-position: 0 0;
}

#localization .flag.flag-nl {
  background-position: 0 -11px;
}
</style>
